import React, { Component } from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import DeviceCard from '../elements/DeviceCard';
import Button from '../elements/Button';
import SendButton from '../elements/SendButton';
import Heading from '../elements/PageHeading';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: auto;
  color: ${props => props.theme.secondary};
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px auto 0px;
  alignitems: 'center';
`;

class IdentificationPage extends Component {
  render() {
    const {
      t,
      target,
      cancel,
      startShelfIdentification,
      stopShelfIdentification,
    } = this.props;

    return (
      <Wrapper>
        <Heading text={t('management.identification')} />
        <DeviceCard device={target || {}} />
        &nbsp;&nbsp;&nbsp;
        <Buttons>
          <Button onClick={cancel}>{t('button.cancel')}</Button>
          &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
          <SendButton
            onClick={() => startShelfIdentification()}
            text={t('button.startIdentification')}
          />
          &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
          <SendButton
            onClick={() => stopShelfIdentification()}
            text={t('button.stopIdentification')}
          />
        </Buttons>
      </Wrapper>
    );
  }
}

export default translate()(IdentificationPage);
